import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Facturation/Facturation.css"; // On réutilise le même CSS pour la cohérence des tableaux

const Archives = () => {
    const navigate = useNavigate();
    const [archives, setArchives] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchArchives = async () => {
        try {
            // On récupère uniquement l'étape 19 (Archives)
            const res = await fetch("https://kanban.amservices.eu//api/get_suivis.php?etape=500", { credentials: "include" });
            const data = await res.json();
            if (data.success) setArchives(data.data);
        } catch (err) {
            console.error("Erreur archives:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchArchives(); }, []);

    // Filtrage pour la barre de recherche (indispensable en archive)
    const filteredArchives = archives.filter(a =>
        a.client_nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (a.num_bat && a.num_bat.toString().includes(searchTerm))
    );

    if (loading) return <div className="loading-screen">Ouverture des coffres...</div>;

    return (
        <div className="facturation-page">
            <div className="facture-header">
                <button className="btn-back" onClick={() => navigate("/suivi-production")}>
                    ← Retour au Kanban
                </button>
                <div className="header-titles">
                    <h1>Archives Dossiers</h1>
                    <p>{archives.length} dossier(s) archivé(s)</p>
                </div>
                <div className="search-bar-container">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="Rechercher (Client, BAT, Resp)..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                    {searchTerm && (
                        <button className="clear-search" onClick={() => setSearchTerm("")}>✖</button>
                    )}
                </div>
            </div>

            <div className="billing-container">
                <table className="billing-table">
                    <thead>
                        <tr>
                            <th>Client</th>
                            <th>BAT</th>
                            <th>Date Archivage</th>
                            <th>Responsable</th>
                            <th>Statut</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArchives.map((a) => (
                            <tr key={a.id} className="billing-row archive-row">
                                <td className="client-cell"><strong>{a.client_nom}</strong></td>
                                <td>{a.num_bat ? `#${a.num_bat}` : "-"}</td>
                                <td>{new Date(a.updated_at || a.date_echeance).toLocaleDateString('fr-FR')}</td>
                                <td><div className="resp-badge">{a.responsable_nom}</div></td>
                                <td><span className="status-archive">✅ Payé / Terminé</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {filteredArchives.length === 0 && <div className="empty-state">Aucun dossier trouvé dans les archives.</div>}
            </div>
        </div>
    );
};

export default Archives;